export default __webpack_public_path__ + "static/media/L-A-correct.141cb423.png";